var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10Balcony(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3478 19.8147H26.4348H27.9842V19.4353V18.6764H4V19.4353H5.56522V19.8147H7.65217V19.4353H11.8261V19.8147H13.913V19.4353H18.087V19.8147H20.1739V19.4353H24.3478V19.8147Z",
    fill: "#F1CA65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3478 19.4353H20.1739V19.8147H24.3478V19.4353Z",
    fill: "#F1CA65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.087 19.4353H13.913V19.8147H18.087V19.4353Z",
    fill: "#F1CA65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8261 19.4353H7.65217V19.8147H11.8261V19.4353Z",
    fill: "#F1CA65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.4353V19.8147H5.56522V19.4353H4Z",
    fill: "#F1CA65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4348 25.6962V19.8147H24.3478V25.6962H20.1739V19.8147H18.087V25.6962H13.913V19.8147H11.8261V25.6962H7.65217V19.8147H5.56522V25.6962H4V27.7831H28V25.6962H26.4348Z",
    fill: "#F1CA65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24267 13.059L10.4125 16.21L10.6429 16.7792H16.0641L16.2753 16.21L17.4451 13.059C17.6442 12.3289 17.0945 11.6092 16.3377 11.6092H14.3874V9.18524L15.6674 8.69316C16.2024 8.47913 16.4619 7.86223 16.2479 7.32716C16.0339 6.79208 15.4284 6.5098 14.8933 6.72384L14.3874 6.93752V5.25348C14.3874 4.67718 13.9202 4.21 13.3439 4.21C12.7676 4.21 12.3004 4.67718 12.3004 5.25348V8.59624L11.5333 8.34056C10.9866 8.15832 10.3957 8.45379 10.2134 9.00051C10.0312 9.54724 10.3267 10.1382 10.8734 10.3204L12.3004 10.7961V11.6092H10.3501C9.59321 11.6092 9.04354 12.3289 9.24267 13.059ZM14.1741 15.9799C14.179 15.9657 14.1838 15.9515 14.1898 15.9377L14.9814 14.1482C14.9874 14.1344 14.9927 14.1203 14.9957 14.1056C15.0386 13.8961 14.8786 13.6962 14.661 13.6962H12.0267C11.8091 13.6962 11.6491 13.8961 11.692 14.1056C11.695 14.1203 11.7003 14.1344 11.7064 14.1482L12.4979 15.9377C12.504 15.9515 12.5088 15.9657 12.5137 15.9799C12.5609 16.1168 12.6901 16.21 12.8365 16.21H13.8512C13.9977 16.21 14.1269 16.1168 14.1741 15.9799Z",
    fill: "#F1CA65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17.3483H18.5613H15.853H10.8734H4V18.6764H27.9842V19.4353H28V17.3483Z",
    fill: "#F1CA65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Balcony);
export default __webpack_public_path__ + "static/media/10-Balcony.875ca81fd7fbd9f3b057e5b9837c8405.svg";
export { ForwardRef as ReactComponent };